var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "124px",
    viewBox: "0 0 124 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E23BE6C2-FC66-4146-AE3A-64E60A5E5017") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RESULTS-2",
    transform: "translate(-1095.000000, -1711.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(10.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-7",
    transform: "translate(645.000000, 1039.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(440.000000, 476.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    fill: "#FFCE07",
    cx: 62,
    cy: 62,
    r: 60.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-line",
    transform: "translate(62.000000, 62.000000) rotate(-180.000000) translate(-62.000000, -62.000000) translate(22.842105, 22.842105)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 78.3157895 0 78.3157895 78.3157895 0 78.3157895"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3A3A3C",
    fillRule: "nonzero",
    points: "28.9474737 36.8916316 58.7368421 36.8916316 58.7368421 41.7863684 28.9474737 41.7863684 42.0751579 54.9140526 38.6145789 58.3746316 19.5789474 39.339 38.6145789 20.3033684 42.0751579 23.7639474"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIcon);
export default __webpack_public_path__ + "static/media/selected-icon.688bd7d5bc430108593745d39defebfe.svg";
export { ForwardRef as ReactComponent };